import { SelectArrayInput as RaSelectArrayInput } from 'react-admin';
import { styled } from '@mui/material';

const SelectArrayInput = styled(RaSelectArrayInput)({
  minWidth: '14.5rem',
});

export default SelectArrayInput;
